import { Injectable } from "@angular/core";
import { BaseService } from "../../../shared/Services/BaseService";
import { HttpClient } from "@angular/common/http";
import { authenticationService } from "../../../shared/Services/authenticationService";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class PortalService extends BaseService {
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    const baseUrl = environment.apiUrl + 'Portals';
    super(http, authenticationSerives, baseUrl);
  }
}